import request from "./request";
/**
 * 解除授权
 * @param pageId 专页id
 */
export default async function revokeAuthorization(data) {
  return await request.post(
    "/spin/dataAuthorization/revokeAuthorization",
    data
  );
}
